import { SettingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import { useCanEditHelp } from "../../hooks/useHelpCentre";

interface ConfigureLinkProps {
	/** What it does, such as "Configure topics": its tooltip and accessible name. */
	label: string;
	/** Where it leads; without it, a button that runs `onClick`. */
	to?: string;
	onClick?: () => void;
}

/** The gear that takes an editor to the configuration. Nobody else sees it. */
function ConfigureLink({ label, to, onClick }: Readonly<ConfigureLinkProps>) {
	const { canEdit } = useCanEditHelp();
	if (!canEdit) return null;
	const icon = <SettingOutlined aria-hidden="true" />;
	return (
		<Tooltip title={label}>
			{to ? (
				<Link className="help-configure" to={to} aria-label={label}>
					{icon}
				</Link>
			) : (
				<button
					type="button"
					className="help-configure"
					onClick={onClick}
					aria-label={label}
				>
					{icon}
				</button>
			)}
		</Tooltip>
	);
}

export default ConfigureLink;
